import Vue from 'vue'
import Vuex from 'vuex'
import Tool from '../common/tool'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    currentUserInfo: Tool.getStorage('dpm_userinfo'),
    appInfo: Tool.getStorage('appInfo')
  },
  getters: {
    getCurrentUserInfo (state) {
      return state.currentUserInfo
    },
    getAppInfo (state) {
      return state.appInfo
    }
  },
  mutations: {
    setCurrentUserInfo (state, currentUserInfo) {
      state.currentUserInfo = currentUserInfo
      Tool.setStorage('dpm_userinfo', currentUserInfo)
    },
    setAppInfo (state, appInfo) {
      state.appInfo = appInfo
      Tool.setStorage('appInfo', appInfo)
    }
  },
  actions: {},
  modules: {}
})
